// extracted by mini-css-extract-plugin
export default {"quote":"PxiQJ4szFexyBKUFjkgd","text":"R7s9KbQiW9ffxfVJtoOn","participant":"tPXjoqMA2995Osk7EByu"};